import { z } from 'zod';

const basePredictionSchema = z
  .object({
    formName: z.string(),
    usState: z.string(),
    version: z.string().nullable().optional(),
    documentCategory: z.string().nullable().optional(),
    documentType: z.string().nullable().optional(),
    searchRegex: z.string().nullable().optional(),
    score: z.number(),
    containment: z.number().optional(),
    pageNumber: z.number(),
  })
  .passthrough();

const documentPagePredictionSchema = basePredictionSchema
  .extend({
    classificationMethod: z.string().optional(),
    alternativeCandidates: z.array(basePredictionSchema).optional(),
  })
  .passthrough();

type DocumentClassification = z.infer<typeof documentPagePredictionSchema>;

export {
  basePredictionSchema,
  DocumentClassification,
  documentPagePredictionSchema,
};
